/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { reaction, IReactionDisposer } from 'mobx';
import type { Component } from 'react';

interface bindReactionConfig{
    stateName: string,
    managerStateName: string
}

/**
 * manager和component之间，可以直接进行数据reaction绑定
 */
export default class ReactionBridgeHelper {
    public reactionList: IReactionDisposer[];

    constructor() {
        this.reactionList = [];
    }

    public bindMultiReaction(bindReactionConfigList: bindReactionConfig[], component: Component): IReactionDisposer[] {
        const bindReactionList: IReactionDisposer[] = [];
        bindReactionConfigList.forEach((configItem: bindReactionConfig) => {
            bindReactionList.push(this.bindReaction(
                configItem.stateName,
                configItem.managerStateName,
                component,
            ));
        });
        return bindReactionList;
    }

    public bindReaction(stateName: string, managerStateName: string, component: Component): IReactionDisposer {
        const newReaction: IReactionDisposer = reaction(
            () => this[managerStateName],
            (newStateName) => {
                component.setState({
                    [stateName]: newStateName,
                });
            },
        );
        this.reactionList.push(newReaction);
        return newReaction;
    }

    public flushReaction(): void {
        this.reactionList = this.reactionList.filter((reactionItem: IReactionDisposer) => {
            reactionItem();
            return false;
        });
    }
}
